import React from 'react';
import { GroupedTimesheets } from '../../components/common/GroupedTimesheets';

export function AllTimesheets() {
  return <GroupedTimesheets scope="all" pageTitle="All Timesheets" />;
}

export default AllTimesheets;
